import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 180000 });

export const parseText = (text, servings) =>
  api.post("/recipes/from-text", { text, servings }).then(r => r.data);

export const parseUrl = (url, servings) =>
  api.post("/recipes/from-url", { url, servings }).then(r => r.data);

export const parseManual = (name, servings, ingredients) =>
  api.post("/recipes/from-manual", { name, servings, ingredients }).then(r => r.data);

export const parseAudio = (file, servings) => {
  const fd = new FormData(); fd.append("file", file); fd.append("servings", servings);
  return api.post("/recipes/from-audio", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};

export const parseVideo = (file, servings) => {
  const fd = new FormData(); fd.append("file", file); fd.append("servings", servings);
  return api.post("/recipes/from-video", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};

export const listRecipes = () => api.get("/recipes").then(r => r.data);
export const getRecipe = (id) => api.get(`/recipes/${id}`).then(r => r.data);
export const deleteRecipe = (id) => api.delete(`/recipes/${id}`).then(r => r.data);
export const searchFoods = (q) => api.get("/foods/search", { params: { q } }).then(r => r.data);
export const getDailyValues = () => api.get("/daily-values").then(r => r.data);

// New endpoints
export const getDriProfiles = () => api.get("/dri/profiles").then(r => r.data);
export const getDri = (key) => api.get(`/dri/${key}`).then(r => r.data);
export const getCategories = () => api.get("/ingredients/categories").then(r => r.data);
export const getIngredientsAll = (category) =>
  api.get("/ingredients/all", { params: category ? { category } : {} }).then(r => r.data);
export const getIngredientsTop = (nutrient, limit = 10) =>
  api.get("/ingredients/top", { params: { nutrient, limit } }).then(r => r.data);
export const previewRecipe = (name, servings, ingredients) =>
  api.post("/recipes/preview", { name, servings, ingredients }).then(r => r.data);
export const saveBuilderRecipe = (name, servings, ingredients) =>
  api.post("/recipes/from-builder", { name, servings, ingredients }).then(r => r.data);
export const addToMealLog = (date, recipeId, servingsEaten = 1) =>
  api.post("/meal-log/entries", { date, recipe_id: recipeId, servings_eaten: servingsEaten }).then(r => r.data);
export const getMealLog = (date, profile) =>
  api.get("/meal-log", { params: { date, profile } }).then(r => r.data);
export const deleteMealLogEntry = (id) =>
  api.delete(`/meal-log/entries/${id}`).then(r => r.data);
export const compareRecipes = (a, b) =>
  api.get("/recipes/compare", { params: { a, b } }).then(r => r.data);

// Search the web (LLM-powered)
export const searchWebRecipes = (query, count = 3) =>
  api.post("/recipes/search-web", { query, count }).then(r => r.data);
export const saveSearchedRecipe = (payload) =>
  api.post("/recipes/search-web/save", payload).then(r => r.data);

// Weekly summary + deficit fixer
export const getMealLogWeek = (start, profile) =>
  api.get("/meal-log/week", { params: { start, profile } }).then(r => r.data);
export const getDeficitSuggestions = (date, profile, dietTags = []) =>
  api.get("/meal-log/deficit-suggestions", { params: { date, profile, diet_tags: dietTags.join(",") } }).then(r => r.data);

// Grocery
export const groceryFromWeek = (start, multiplier = 1) =>
  api.get("/grocery/from-week", { params: { start, multiplier } }).then(r => r.data);
export const groceryCustom = (items) =>
  api.post("/grocery/custom", { items }).then(r => r.data);

// Coach
export const getCoach = (date, profile) =>
  api.get("/coach", { params: { date, profile } }).then(r => r.data);

// Combinations
export const getCombinations = (ingredients) =>
  api.get("/combinations", { params: { ingredients: ingredients.join(",") } }).then(r => r.data);
export const getRecipeCombinations = (recipeId) =>
  api.get(`/recipes/${recipeId}/combinations`).then(r => r.data);

// Remix
export const remixRecipe = (originalId, name, servings, ingredients, persist = false) =>
  api.post("/recipes/remix", { original_id: originalId, name, servings, ingredients, persist }).then(r => r.data);

// Import from photo
export const parseImage = (file, servings) => {
  const fd = new FormData(); fd.append("file", file); fd.append("servings", servings);
  return api.post("/recipes/from-image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};

// Meal planner
export const savePlanner = (payload) =>
  api.post("/planner", payload).then(r => r.data);
export const listPlanners = () => api.get("/planner").then(r => r.data);
export const getPlanner = (id) => api.get(`/planner/${id}`).then(r => r.data);
export const deletePlanner = (id) => api.delete(`/planner/${id}`).then(r => r.data);
export const getPlannerSummary = (id) => api.get(`/planner/${id}/summary`).then(r => r.data);

// Grocery assistant
export const getGroceryStores = () => api.get("/grocery/stores").then(r => r.data);
export const getGroceryRoute = (items, store) =>
  api.post("/grocery/route", { items, store }).then(r => r.data);

// Voice cook
export const getRecipeSteps = (id) => api.get(`/recipes/${id}/steps`).then(r => r.data);
export const askCoach = (question, recipeId, stepIdx) =>
  api.post("/coach/ask", { question, recipe_id: recipeId, step_idx: stepIdx }).then(r => r.data);

// Amino score
export const getAminoScore = (id) => api.get(`/recipes/${id}/amino-score`).then(r => r.data);
export const getSubstitutions = (id, limit = 5) =>
  api.get(`/recipes/${id}/substitutions`, { params: { limit } }).then(r => r.data);

// Auto-plan
export const autoGeneratePlan = (payload) =>
  api.post("/planner/auto-generate", payload).then(r => r.data);

// Kids Mode
export const getKidsConfig = () => api.get("/kids/config").then(r => r.data);
export const getKidSnackIdeas = (planId, personId, date, limit = 5) =>
  api.get("/kids/snack-ideas", { params: { plan_id: planId, person_id: personId, date, limit } }).then(r => r.data);

export const NUTRIENT_LABELS = {
  // Energy
  calories: "Calories",
  // Macros
  protein: "Protein", carbs: "Carbs", fat: "Fat", fiber: "Fiber", sugar: "Sugar",
  cholesterol: "Cholesterol", saturated_fat: "Saturated Fat", trans_fat: "Trans Fat",
  mono_fat: "Monounsaturated Fat", poly_fat: "Polyunsaturated Fat", omega3: "Omega-3",
  // Vitamins
  vitamin_a: "Vitamin A", vitamin_c: "Vitamin C", vitamin_d: "Vitamin D",
  vitamin_e: "Vitamin E", vitamin_k: "Vitamin K",
  vitamin_b1: "Vitamin B1 (Thiamine)", vitamin_b2: "Vitamin B2 (Riboflavin)",
  vitamin_b3: "Vitamin B3 (Niacin)", vitamin_b5: "Vitamin B5 (Pantothenic acid)",
  vitamin_b6: "Vitamin B6", vitamin_b7: "Vitamin B7 (Biotin)",
  folate: "Vitamin B9 (Folate)", vitamin_b12: "Vitamin B12", choline: "Choline",
  // Macrominerals
  calcium: "Calcium", phosphorus: "Phosphorus", magnesium: "Magnesium",
  sodium: "Sodium", potassium: "Potassium", chloride: "Chloride", sulfur: "Sulfur",
  // Trace minerals
  iron: "Iron", zinc: "Zinc", copper: "Copper", manganese: "Manganese",
  iodine: "Iodine", selenium: "Selenium", molybdenum: "Molybdenum",
  chromium: "Chromium", boron: "Boron", cobalt: "Cobalt", fluoride: "Fluoride",
};

export const NUTRIENT_UNITS = {
  calories: "kcal",
  // Macros — all in grams except cholesterol (mg)
  protein: "g", carbs: "g", fat: "g", fiber: "g", sugar: "g",
  saturated_fat: "g", trans_fat: "g", mono_fat: "g", poly_fat: "g", omega3: "g",
  cholesterol: "mg",
  // Vitamins
  vitamin_a: "µg", vitamin_c: "mg", vitamin_d: "µg", vitamin_e: "mg", vitamin_k: "µg",
  vitamin_b1: "mg", vitamin_b2: "mg", vitamin_b3: "mg", vitamin_b5: "mg",
  vitamin_b6: "mg", vitamin_b7: "µg", folate: "µg", vitamin_b12: "µg", choline: "mg",
  // Macrominerals
  calcium: "mg", phosphorus: "mg", magnesium: "mg",
  sodium: "mg", potassium: "mg", chloride: "mg", sulfur: "mg",
  // Trace minerals
  iron: "mg", zinc: "mg", copper: "mg", manganese: "mg",
  iodine: "µg", selenium: "µg", molybdenum: "µg", chromium: "µg",
  boron: "mg", cobalt: "µg", fluoride: "mg",
};

// Grouped presentation for tables + infographic charts.
export const NUTRIENT_CATEGORIES = {
  energy:         { label: "Energy",         keys: ["calories"] },
  macros:         { label: "Macronutrients", keys: ["protein", "carbs", "fat", "fiber", "sugar", "saturated_fat", "trans_fat", "mono_fat", "poly_fat", "omega3", "cholesterol"] },
  vitamins:       { label: "Vitamins",       keys: ["vitamin_a", "vitamin_c", "vitamin_d", "vitamin_e", "vitamin_k",
                                                    "vitamin_b1", "vitamin_b2", "vitamin_b3", "vitamin_b5", "vitamin_b6",
                                                    "vitamin_b7", "folate", "vitamin_b12", "choline"] },
  macrominerals:  { label: "Macrominerals",  keys: ["calcium", "phosphorus", "magnesium", "sodium", "potassium", "chloride", "sulfur"] },
  trace_minerals: { label: "Trace minerals", keys: ["iron", "zinc", "copper", "manganese", "iodine", "selenium",
                                                     "molybdenum", "chromium", "boron", "cobalt", "fluoride"] },
};

// Standard set for the top-of-page summary chart (10 most-visible nutrients).
export const STANDARD_CHART_KEYS = [
  "calories", "protein", "carbs", "fat", "fiber",
  "iron", "calcium", "vitamin_d", "vitamin_c", "sodium",
];

export const MACRO_KEYS = NUTRIENT_CATEGORIES.macros.keys;
export const VITAMIN_KEYS = NUTRIENT_CATEGORIES.vitamins.keys;
export const MINERAL_KEYS = [...NUTRIENT_CATEGORIES.macrominerals.keys, ...NUTRIENT_CATEGORIES.trace_minerals.keys];

export const DIET_TAG_META = {
  vegan: { label: "Vegan", color: "#7A9A7C" },
  vegetarian: { label: "Vegetarian", color: "#8FAE7B" },
  dairy_free: { label: "Dairy-free", color: "#3B5A5C" },
  gluten_free: { label: "Gluten-free", color: "#D99D41" },
  keto: { label: "Keto", color: "#C84C31" },
  low_carb: { label: "Low-carb", color: "#B8956A" },
  high_protein: { label: "High-protein", color: "#4A5559" },
  low_sodium: { label: "Low-sodium", color: "#8B6F47" },
};
